module.exports = __webpack_public_path__ + "img/garnelenbowlfront.858ccce3.png";